
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 2.91c0-.66.518-1.196 1.157-1.196h13.686c.639 0 1.157.536 1.157 1.196v8.269c0 .66-.518 1.196-1.157 1.196h-3.729l1.718.644a.743.743 0 01-.521 1.39L8 12.794 3.69 14.41a.743.743 0 11-.522-1.391l1.718-.644H1.157C.518 12.375 0 11.839 0 11.179V2.91zm14.62.231v7.807H1.38V3.14h13.24z","fill":"#9DA7B2"}})])
          )
        }
      }
    